
export default {
  name: "Article",
  scrollToTop: true,
  async asyncData({ $content, params, error }) {
    const slug = params.slug || "index";
    const article = await $content(`articles/${slug}`)
      .fetch()
      .catch(() => {
        error({ statusCode: 404, message: "article not found" });
      });

    const seoTitle = await article.title.slice(0, 57);
    const seoDescription = await article.description.slice(0, 300);

    const [prev, next] = await $content(`articles`)
      .surround(slug)
      .only(["title", "slug"])
      .sortBy("date", "desc")
      .fetch()
      .catch(() => {
        this.error({ statusCode: 404, message: "article not found" });
      });

    return {
      article,
      seoTitle,
      seoDescription,
      prev,
      next,
    };
  },
  data() {
    return {
      dateOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    };
  },
  head() {
    return {
      title: this.seoTitle,
      titleTemplate: "%s | INDOMASCOT",
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: "description",
          name: "description",
          content: this.seoDescription,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.article.image,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          content: this.article.name,
        },
        {
          hid: "og:type",
          name: "og:type",
          content: this.article.type,
        },
        {
          hid: "og:url",
          name: "og:url",
          content: this.article.url,
        },
        {
          hid: "og:title",
          name: "og:tit57",
          content: this.article.title,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.seoDescription,
        },
        {
          hid: "twitter:card",
          name: "twitter:card",
          content: this.article.card,
        },
        {
          hid: "twitter:site",
          name: "twitter:site",
          content: this.article.site,
        },
        {
          hid: "twitter:creator",
          name: "twitter:creator",
          content: this.article.creator,
        },
        {
          hid: "twitter:title",
          name: "twitter:tit57",
          content: this.article.title,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.seoDescription,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.article.image,
        },
      ],
    };
  },
};
